<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="app-bar-user-avatar"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          v-on="on"
        >
          <v-img :src="$store.getters.avatarUrl"></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar size="40px">
            <v-img :src="$store.getters.avatarUrl"></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span
            v-if="userName"
            class="text--primary font-weight-semibold mb-n1 wrapper-name"
          >
            {{ userName.extra_data.name }}
          </span>
        </div>
      </div>

      <v-divider class="my-2"></v-divider>

      <!-- Profile -->
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <router-link
            to="/account-settings"
            class="d-flex align-center text-decoration-none"
          >
            <v-list-item-title>{{ $t("Edit Profile") }}</v-list-item-title>
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <!-- View Profile -->
      <v-list-item
        v-if="userName && userName.extra_data && userName.extra_data.username"
        link
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiEyeOutline }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <router-link
            :to="`/user/${userName.extra_data.username}`"
            class="d-flex align-center text-decoration-none"
          >
            <v-list-item-title>{{ $t("View Profile") }}</v-list-item-title>
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <!-- Email -->
      <v-list-item @click="openInstallDialog">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiDownload }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Install / Instructions") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiEmailOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Inbox") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Chat -->
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiChatOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Chat") }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-badge
            inline
            color="error"
            content="2"
          >
          </v-badge>
        </v-list-item-action>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Pricing -->
      <v-list-item to="/billing">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCurrencyUsd }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Subscription & credits") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- FAQ -->
      <v-list-item to="/referrals">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content><v-list-item-title>{{ $t("Referrals & affiliates") }}</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="referralAdmin"
        to="/admin"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content><v-list-item-title>{{ $t("Administration") }}</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiHelpCircleOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("FAQ") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <router-link
            to="/auth"
            class="d-flex align-center text-decoration-none"
          >
            <v-list-item-title>{{ $t("Logout") }}</v-list-item-title>
          </router-link>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiEyeOutline,
  mdiDownload,
} from '@mdi/js'
import { canAdminReferrals } from '@/services/referrals'
import { openInstallDialog } from '@/services/pwa'

export default {
  data() {
    return {
      icons: {
        mdiDownload,
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiEyeOutline,
      },

    }
  },
  computed: {
    referralAdmin() { return canAdminReferrals(this.$store.state.jwtToken) },
    userName() {
      return this.$store.state.user
    },
  },
  methods: { openInstallDialog },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}

.wrapper-name {
  width: 95%;
  word-break: break-word;
  display: block;
}
</style>
